import { dropDownList } from "@/api/common";

// import { TYPE } from '@/enum/global';
// import router from "../../router";
// import axios from "axios";
// import moment from 'moment';


const state = () => ({
    categories: {},
    behavior :[],
    frequency : [],
    severity: [],
    windowsKB: [],
    requestLoading: 0,
    goIndexRefresh: true, // CreateNew頁面點選側邊攔要回到step 1
    windowsKBSeverity: [], // windows KB severity
});

// getters
const getters = {};

// actions
const actions = {
    async getDropDownList({ commit, dispatch, state }) {
        const { data } = await dropDownList();
        // console.log("????dropDownList",data)

        commit("setBehavior", data.update_behavior);
        commit("setCategory", data.category);
        commit("setFrequency", data.auto_check_frequency);
        commit("setSeverity", data.severity);
        commit("setWindowsKB", data.windows_kb);
        commit("setWindowsKBSeverity", data.windows_kb_severity);
    },
    
    // setLoadingAction ({ commit }, boolean) {
    //     commit('setLoading', boolean)
    // },

};

// mutations
const mutations = {
    setBehavior(state, data){
        state.behavior = data
    },
    setCategory(state, data) {
        state.categories = data
    },
    setFrequency(state, data){
        state.frequency = data
    },
    setSeverity(state, data) {
        state.severity = data
    },
    setLoading: (state, boolean) => {
        boolean ? ++state.requestLoading : --state.requestLoading
        // console.log(state.requestLoading ? '有': '沒',state.requestLoading)
    },
    setGoIndexRefresh(state, data) {
        state.goIndexRefresh = data
    },
    setWindowsKB(state, data) {
        state.windowsKB = data
    },
    setWindowsKBSeverity(state, data) {
        state.windowsKBSeverity = data
    }
};



export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};